import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import {
  ShowRequiredField,
  StudentTypeList,
  AcademicList,
  kPButton,
} from "../global";
import AdmissionContext from "../AdmissionContext";

class CourseView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);
    this.state = {
      preferredLabel: "Preferred",
      secondChoiceLabel: "Second Choice",
    };
  }

  studentTypeValueChanged = (event, value) => {
    const { studentType } = this.context;
    studentType.required = false;
    studentType.studentType = value;
    this.context.SetStudentType(studentType);
  };

  academicValueChanged = (event, value) => {
    const { studentType, undergraduate, graduate } = this.context;
    studentType.required = false;
    studentType.academic = value;

    studentType.preferred = null;
    studentType.secondChoice = null;

    this.context.SetPreferredCourse([]);
    this.context.SetSecondChoiceCourse([]);

    if (value !== null) {
      if (value.description.toLowerCase() === "graduate") {
        this.context.SetPreferredCourse(graduate);
        this.setState({
          preferredLabel: "Pogram",
          secondChoiceLabel: "Major",
        });
      } else {
        this.context.SetPreferredCourse(undergraduate);
        this.setState({
          preferredLabel: "Preferred",
          secondChoiceLabel: "Second Choice",
        });
      }
    }

    this.context.SetStudentType(studentType);
  };

  preferredValueChanged = (event, value) => {
    const { studentType } = this.context;
    studentType.required = false;
    studentType.preferred = value;
    studentType.secondChoice = null;
    this.context.SetSecondChoiceCourse([]);

    if (value !== null) {
      if (studentType.academic !== null) {
        //set second choice
        if (studentType.academic.description.toLowerCase() === "graduate") {
          //graduate
          this.context.SetSecondChoiceCourse(value.major);
        } else {
          //undergraduate
          var list = [];
          for (const item of this.context.preferred) {
            if (item.code !== value.code) {
              list.push(item);
            }
          }

          this.context.SetSecondChoiceCourse(list);
        }
      }
    }

    //value.description.toLowerCase() === "graduate"

    this.context.SetStudentType(studentType);
  };

  majorValueChanged = (event, value) => {
    const { studentType } = this.context;
    studentType.required = false;
    studentType.major = value;
    this.context.SetStudentType(studentType);
  };

  secondChoiceValueChanged = (event, value) => {
    const { studentType } = this.context;
    studentType.required = false;
    studentType.secondChoice = value;
    this.context.SetStudentType(studentType);
  };

  checkRequireFields = (index) => {
    const { studentType } = this.context;

    if (studentType.required) {
      if (index === 0) {
        if (studentType.studentType === null) {
          return ShowRequiredField("Student Type");
        }
      } else if (index === 1) {
        if (studentType.preferred === null) {
          return ShowRequiredField("Preferred");
        }
      } else if (index === 2) {
        // if (studentType.secondChoice === null) {
        //   return ShowRequiredField("Second Choice");
        // }
      }
    }

    return null;
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { studentType } = this.context;
    if (studentType.studentType === null || studentType.preferred === null) {
      studentType.required = true;
      this.context.SetStudentType(studentType);
      return;
    } else {
      this.context.btnNextClicked();
    }
  };

  render() {
    const { studentType } = this.context;
    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Student Type
                  </Box>
                </Typography>

                <Box pt={2}>
                  <Autocomplete
                    id="cboStudentType"
                    options={StudentTypeList}
                    value={studentType.studentType}
                    getOptionLabel={(item) =>
                      item.description ? item.description : ""
                    }
                    fullWidth={true}
                    onChange={this.studentTypeValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Student Type"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(0)}

                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                    pt={2}
                  >
                    Select your course/program
                  </Box>
                </Typography>

                <Box pt={2}>
                  <Autocomplete
                    id="cboAcademics"
                    options={AcademicList}
                    value={studentType.academic}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.academicValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Academic"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(1)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboPreferred"
                    options={this.context.preferred}
                    value={studentType.preferred}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.preferredValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={this.state.preferredLabel}
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(1)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboSecondChoice"
                    options={this.context.secondChoice}
                    value={studentType.secondChoice}
                    getOptionLabel={(item) => item.description}
                    fullWidth={true}
                    onChange={this.secondChoiceValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={this.state.secondChoiceLabel}
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(2)}

                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      disabled={true}
                      fullWidth={true}
                      style={{
                        height: 42,
                        borderRadius: 10,
                        // backgroundColor: "#388e3c",
                        backgroundColor: "#9E9E9E",
                        color: "white",
                      }}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }
}

export default CourseView;
